module.exports = __webpack_public_path__ + "static/media/chevron-arrow-up.43ea9c76.svg";